export enum InstallmentStatusEnum {
    PAID = 'PAID',
    LATE = 'LATE',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    CANCELED = 'CANCELED',
}